import { getGuideUrl } from '@change-corgi/config/guides';
import { useI18n } from '@change-corgi/core-react/i18n';

import { useLocale } from '#src/app/shared/hooks/l10n';

import { processLinkGroup } from './processLinkGroup';
import type { LinkGroup } from './types';

export function useLearnLinks(): LinkGroup | null {
	const { translate } = useI18n();
	const locale = useLocale();
	const sourceLocation = 'source_location=footer_link';

	const homeLink = getGuideUrl(locale, 'home');
	const createPetitionLink = getGuideUrl(locale, 'createPetition');
	const sharePetitionLink = getGuideUrl(locale, 'sharePetition');
	const reachMediaLink = getGuideUrl(locale, 'reachMedia');
	const engageDecisionMakerLink = getGuideUrl(locale, 'engageDecisionMaker');

	// If there's no home link, we assume there are no guides for locale
	if (!homeLink) return null;

	return processLinkGroup({
		title: translate('corgi.components.footer.section.learn'),
		links: [
			{
				href: `${homeLink}?${sourceLocation}`,
				title: translate('corgi.components.footer.links.petition_guides'),
			},
			{
				href: `${createPetitionLink}?${sourceLocation}`,
				title: translate('corgi.components.footer.links.create_petition'),
			},
			{
				href: `${sharePetitionLink}?${sourceLocation}`,
				title: translate('corgi.components.footer.links.collect_signatures'),
			},
			{
				href: `${reachMediaLink}?${sourceLocation}`,
				title: translate('corgi.components.footer.links.reach_out_to_media'),
			},
			{
				href: `${engageDecisionMakerLink}?${sourceLocation}`,
				title: translate('corgi.components.footer.links.engage_decision_maker'),
			},
		],
	});
}
